export const getBblCode = (): string => {
  return window.config.bblCode?.toLowerCase() ?? ''
}

export const isNbbo = (): boolean => {
  return window.config.bblCode.toLowerCase() === 'nbbo'
}
